<template>
  <div>
    <section v-if="scheduleAvailable" class="leagues-home hero is-success is-bold">
      <div class="hero-body">
        <schedule-container></schedule-container>
      </div>
    </section>
    <section v-if="signupsAvailable" class="leagues-home hero is-success is-bold">
      <div class="hero-body">
        <signup-container></signup-container>
      </div>
    </section>
    <section v-else-if="!signupsAvailable" class="leagues-home hero is-warning is-bold">
      <div class="hero-body">
        <h3 class="subtitle">
          Site signups are not available now for {{ season.name }}.
          If you'd still like to signup, please email <a href="mailto:TheBeachAtSharkeys@gmail.com">TheBeachAtSharkeys@gmail.com</a>
        </h3>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import SignupContainer from '@/components/SignupContainer.vue'
import ScheduleContainer from '@/components/ScheduleContainer.vue';
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'LeaguesHome',
  components: {
    SignupContainer,
    ScheduleContainer,
  },
  computed: {
    ...mapState(["currentSeason", "upcomingSeason"]),
    ...mapGetters(["signupsAvailable", "scheduleAvailable"]),
    season: vm => vm.upcomingSeason || vm.currentSeason
  },
  created() {
    this.$store.dispatch("loadInitialLeaguesData");
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.signupsAvailable && vm.currentSeason && vm.scheduleAvailable) {
        vm.$router.replace(`/leagues/schedule/${vm.currentSeason.id}`);
      }
    });
  }
}
</script>
